export const SECTION_LABEL_CLASSNAME =
  "text-[11px] font-semibold uppercase tracking-wide text-secondary-text";
